import { render, staticRenderFns } from "./case-type-form.vue?vue&type=template&id=cba6f6bc&scoped=true"
import script from "./case-type-form.vue?vue&type=script&lang=ts"
export * from "./case-type-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba6f6bc",
  null
  
)

export default component.exports